export const favoritesHeaderText = "$Od";
export const favoritesWithAccountNameHeaderText = "aPd";
export default {favoritesHeaderText,favoritesWithAccountNameHeaderText};